import styled from "styled-components";

export const LoanIPOWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "100%")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "60%")};
  #login-form {
    display: flex;
    flex-direction: column;
    // row-gap: 2rem;
    // border: 1.5px solid var(--color-tan_two);
    box-shadow: 33px 33px 66px #9f9f9f, -10px -10px 33px #ffffff;
    box-shadow: -5px -5px 9px rgb(255 255 255 / 45%),
      9px 9px 14px 8px rgb(94 104 121 / 30%);
    box-shadow: rgb(229 229 229) 1px 1px 11px, rgb(255, 255, 255) -1px -1px 17px;
    // padding: 3rem 4rem;
    padding: ${(props) =>
      props.padding ? props.padding : "1em 0rem 0rem 0rem"};
    .lipo-headings {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    #login-tab-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      column-gap: 2rem;
    }
    #login-tab-content {
    }
    @media (max-width: 768px) {
      border: none;
      padding: 0rem;
    }
  }
  .infoCard {
    border: 1px solid #d6b06d;
    border-radius: 0.5rem;
    padding: 1rem;
  }
  .content {
    display: flex;
    align-content: center;
    align-items: center;
    color: #d6b06d;
    display: flex;
    text-align: -webkit-match-parent;
  }
  .pageTitle {
    display: flex;
    justify-content: center;
    font-size: 20px;
  }
  .pageSubTitle {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .heading-line {
    background-color: #c4a167;
    width: 100%;
    text-align: center;
    margin-top: 10px;
    color: #ffffff;
    font-size: 16px;
  }
  .range-selector-container {
    width: 100%;
    padding: 5px 30px 5px 30px;
    justify-content: space-between;
    align-items: center;
  }
  .range-selector-container-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    color: #545454;
  }
  .slider-input {
    border-radius: 10px;
    width: 100%;
    height: 8px;
    margin-top: 15px;
    border: 1px solid #ebebeb;
    background-color: #ebebeb;
  }
  .slider-input-amount-min-max {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
  }
  .display-amount {
    border: 1px solid #ffffff;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    padding-inline: 10px;
    background-color: #ffffff;
    font-size: 18px;
  }
  .tenure {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-top: 10px;
  }
  .tenure-text {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .tenure-text-1 {
    font-size: 18px;
    color: #545454;
    line-height: 20px;
  }
  .tenure-text-2 {
    font-size: 14px;
    line-height: 2px;
    color: #939090;
    padding: 2px 0px;
  }
  .display-months {
    display: flex;
    flex-direction: row;
  }
  .display-months-block {
    height: 30px;
    width: 30px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-right: 5px;
    border-radius: 5px;
  }
  .summary-container {
    display: flex;
    justify-content: center;
    flex-flow: wrap;
  }
  .summary-box {
    display: flex;
    flex-direction: column;
    background-color: #fffbfb;
    margin-top: 15px;
    width: 80%;
    border: 1px solid #ebdede;
    border-radius: 5px;
  }
  .summaryBox-inside {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 2px;
    margin-bottom: 5px;
  }
  .boxContent {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 2px;
    margin-bottom: 5px;
  }
  .view-text {
    text-align: center;
    margin-bottom: 15px;
    margin-top: 5px;
    font-size: 18px;
    color: #545454;
  }
  .download-text {
    border: None;
    background-color: transparent;
    text-decoration: underline;
  }
  .download-img {
    margin-right: 25px;
    margin-left: 10px;
    height: 50px;
    width: 50px;
  }
  .message {
    color: #b78115;
    font-size: 1.5rem;
    padding: 2px 10px;
  }
  .bold-td{
    font-Weight : 600;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    #login-form {
      box-shadow: None;
    }
    .progress-bar-container {
      margin: 0 2em;
    }
  }
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: #cb3443;
    height: 15px;
    width: 15px;
    border-radius: 50%;
  }

  .additional-details-card {
		display: flex;
		flex-direction: column;
		gap: 0.3em;
		color: #6b6b6b;
		width: 100%;
		border-radius: 1em;
		background: #fffbfb;
		border: 1px solid #ae8e68;
		padding: 1em;
		margin-bottom: 1em;
	}

	.additional-details-card > * {
		font-weight: 600;
	}

	.additional-details-card > div {
		display: flex;
		justify-content: space-between;
	}

	.additional-details-card > span + span {
		font-weight: normal;
		margin-bottom: 0.5em;
	}

	.additional-confirm,
	.additional-confirm > * {
		display: flex;
		font-weight: normal;
		flex-direction: row;
		justify-content: space-between;
	}

	.sub-title {
		display: flex;
	}

	.radio-buttons {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.higherAmountRadio {
		height: 6px;
		padding: 6px;
		border-radius: 4px;
		background-color: #d9d9d9;
	}

	.radio-label {
		padding: 0 1rem;
		color: #6b6b6b;
	}

	.higherAmountRadio:checked {
		background-color: #cb3443;
	}

  tr, td {
    border: 1px solid black;
    padding: 8px;
    // text-align: center;
  }
`;
